import i18n, { StringMap, TOptionsBase } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enUS from "./locale/en-US.json";
import ptBR from "./locale/pt-BR.json";
import esES from "./locale/es-ES.json";

export type TranslationSource =
  | "i18n:translation_failed_loading"
  | "i18n:translation_success_loading"
  | "i18n:translation_failed_lang_change"
  | "i18n:translation_success_lang_change"
  | "greetings:welcome"
  | "greetings:about"
  | "greetings:copyright"
  | "action:send_email_confirmation"
  | "action:resend_email_confirmation"
  | "action:recovery_password"
  | "action:create_new_password"
  | "action:create_and_start_now"
  | "action:create_account"
  | "action:proceed_registration"
  | "action:unknown_company"
  | "action:help"
  | "action:save"
  | "title:recovery_password"
  | "title:create_new_password"
  | "title:create_and_start_now"
  | "title:charge_start_trial"
  | "title:join_company_team"
  | "tooltip:reveal_password"
  | "tooltip:email_info"
  | "tooltip:phone_info"
  | "tooltip:cnpj_info"
  | "form:terms_of_use"
  | "form:password_requirements"
  | "form:field:email"
  | "form:field:corp_email"
  | "form:field:password"
  | "form:field:password_confirm"
  | "form:field:cnpj"
  | "form:field:company_name"
  | "form:field:full_name"
  | "form:field:phone"
  | "form:field:card_cvc"
  | "form:field:card_date"
  | "form:field:card_full_name"
  | "form:field:card_number"
  | "form:placeholder:iugu_payment"
  | "form:placeholder:card_number"
  | "form:placeholder:card_full_name"
  | "form:placeholder:card_date"
  | "form:placeholder:card_cvc"
  | "form:placeholder:email"
  | "form:placeholder:corp_email"
  | "form:placeholder:password"
  | "form:placeholder:password_confirm"
  | "form:placeholder:cnpj"
  | "form:placeholder:company_name"
  | "form:placeholder:full_name"
  | "form:placeholder:phone"
  | "form:legend:access_form"
  | "form:legend:corp_form"
  | "form:legend:user_form"
  | "form:legend:charge_data"
  | "form:description:charge_desc"
  | "success:title"
  | "success:subtitle"
  | "success:button_title"
  | "success:header_title"
  | "success:desc_title"
  | "success:desc_1"
  | "success:desc_2"
  | "success:desc_3"
  | "success:desc_4"
  | "success:desc_5"
  | "success:desc_6"
  | "thanks:title"
  | "thanks:subtitle"
  | "thanks:button_title"
  | "thanks:desc"
  | "confirmation:title"
  | "confirmation:subtitle"
  | "confirmation:button_title"
  | "confirmation:desc"
  | "validation:page_not_found"
  | "validation:page_unauthorized"
  | "validation:user_lost"
  | "validation:password_min_chars"
  | "validation:password_min_uppercase_letter"
  | "validation:password_reserved_char"
  | "validation:password_number"
  | "validation:terms_of_use"
  | "validation:required_field"
  | "validation:valid_email"
  | "validation:valid_phone"
  | "validation:valid_cnpj"
  | "validation:valid_password"
  | "validation:valid_confirm_password"
  | "validation:valid_terms_of_use"
  | "error:email_nonexistent"
  | "";

export type TranslationOptions = TOptionsBase & StringMap & { readonly [key: string]: string };

export type TranslationCallback = (
  error: any,
  t: (src: TranslationSource, options: TranslationOptions) => string
) => any;

export type TranslationNamespace = "common";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    // debug: process.env.NODE_ENV !== "production",
    defaultNS: "common",
    fallbackLng: "en", // linguagem padrão
    resources: {
      pt: ptBR,
      en: enUS,
      es: esES
    },
    compatibilityJSON: "v3",
    interpolation: {
      escapeValue: false // not needed for react!!
    }
  });

export default i18n;
